import React from 'react';
import {observer} from 'mobx-react';
import {uuidv4} from '@techsee/techsee-common/lib/core/uuid';
import './ts-resource-checkbox.style.scss';

interface TsResourceCheckboxProps {
    resource: any;
    resourceType: string;
    onCheckboxClicked: (resource: any, resourceType: string) => void;
    isChecked: boolean;
}

// Maintain a stable id per resource without hooks (compatible with older mobx-react observer)
const resourceToCheckboxId = new WeakMap<object, string>();
const getCheckboxIdForResource = (resource: object | undefined | null): string => {
    if (!resource) return uuidv4();
    const existing = resourceToCheckboxId.get(resource);
    if (existing) return existing;
    const created = uuidv4();
    resourceToCheckboxId.set(resource, created);
    return created;
};

const TsResourceCheckbox: React.FC<TsResourceCheckboxProps> = observer(
    ({resource, resourceType, onCheckboxClicked, isChecked}) => {
        const checkboxId = getCheckboxIdForResource(resource);

        const onChange = () => {
            onCheckboxClicked(resource, resourceType);
        };

        return (
            <div className='checkbox'>
                <input
                    id={checkboxId}
                    className={`input-checkbox-${resourceType}`}
                    type='checkbox'
                    checked={isChecked}
                    onChange={onChange}
                    aria-label='Check'
                />
                <span className='md-ripple-container' aria-hidden='true' />
            </div>
        );
    }
);

export default TsResourceCheckbox;
